import { render } from "./fourteen-treatments.vue?vue&type=template&id=1ded2d48"
import script from "./fourteen-treatments.vue?vue&type=script&lang=js"
export * from "./fourteen-treatments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__